// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  HOME_SET_ASSIGNMENT_FORM_OPEN,
} from './constants';

export function setAssignmentFormOpen(schedule, worker, date, roleCombinations, worker_locations, open) {
  return {
    type: HOME_SET_ASSIGNMENT_FORM_OPEN,
    data: {schedule, worker, date, open, roleCombinations, worker_locations}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_SET_ASSIGNMENT_FORM_OPEN:
      let newState = {
        ...state,
        workerAssignmentForm: action.data
      };

      const {schedule, worker, date, roleCombinations, open} = action.data;
      
      if (!open || schedule.scheduleAssignments.some(sa => (sa.workerId === worker.id && (sa.date === date))))
        return newState;
      //add an "empty" assignment:
      let newAssignments = schedule.scheduleAssignments.slice(0); //clone
      let roles = [];
      if (roleCombinations.length > 0)
        roles = roleCombinations[0];
      newAssignments.push({date,location:"",workerId: worker.id,locked: false,roles,scheduleId: schedule.id, dirty:true});
      newState = {
        ...newState,
        schedules: 
        {
          ...newState.schedules,
          [schedule.id]:
          {
            ...newState.schedules[schedule.id],
            scheduleAssignments: newAssignments
          }
        }
      }


      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/setAssignmentFormOpen.js